export const EMPTY_VALUE = '—';

export const PREVIEW_VERSION_LABEL = '0';

export const BUSINESS_APP_ACTIONS = {
  view: 'view',
  editWithKiCode: 'edit_with_kicode',
  useVersion: 'use_version',
  editConfiguration: 'edit_configuration',
  publishPreview: 'publish_preview',
  deletePreview: 'delete_preview',
  deleteApp: 'delete_app',
  deleteVersion: 'delete_version',
  disable: 'disable',
  enable: 'enable',
} as const;
